import clx from "classnames";
import { useIntl } from "react-intl";
const RowInput = ({ field, form, onChange, FormElement, name, label, icon, guide, placeholder, required, className, preferred, keys = null, ...props }) => {
  const intl = useIntl();
  const _error = form?.errors?.[field?.name];
  const values = form?.values ?? {};

  // Render Multi Key Props
  const renderMultiKeyProps = () => {
    return {
      value: keys?.map((key) => (key?.includes(".") ? getNestedValue(values, key) : values?.[key])),
      onChange: (value) => {
        keys?.forEach((key, index) => form?.setFieldValue(key, value?.[index]));
      },
    };
  };

  // Helper function to get nested value
  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((prev, curr) => {
      return prev ? prev[curr] : undefined;
    }, obj);
  };

  // Render Normal Props
  const renderNormalProps = () => {
    return {
      value: field?.value,
      onChange: (value) => (onChange ? onChange(value) : form?.setFieldValue(field?.name, value)),
    };
  };

  return (
    <div className={clx("flex items-center justify-between flex-nowrap", className)}>
      {label && (
        <div className="flex flex-col justify-center w-1/3 mx-0 md:mx-2 flex-shrink-0">
          <div className="flex items-center text-fg font-medium">
            <span>{intl.formatMessage({ id: label ?? "-" })}</span>
            {required && <span className="text-destructive text-sm ml-1">*</span>}
          </div>
          {_error && <span className="text-xs text-destructive leading-none">{intl.formatMessage({ id: _error })}</span>}
        </div>
      )}
      <div className="flex-1">
        <FormElement
          name={name}
          placeholder={intl.formatMessage({
            id: Boolean(placeholder) ? placeholder : name ?? "-",
          })}
          {...(keys ? renderMultiKeyProps() : renderNormalProps())}
          _error={_error}
          preferred={preferred}
          {...props}
        />
      </div>
    </div>
  );
};

export default RowInput;
